/**
 * 支付类型
 */
export enum PaymentType {
  APPLE_PAY = 0, // Apple Pay
  GOOGLE_PAY = 1, // Google Pay
}

/**
 * 产品类型（订阅周期）
 */
export enum PeriodType {
  MONTH = 0, // 月
  HALF_YEAR = 1, // 半年
  YEAR = 2, // 年
  QUARTER = 3, // 季度
}

/**
 * 会员等级
 */
export enum MemberLevel {
  STANDARD = 0, // Pro
  PREMIUM = 1, // Premium
  BASIC = 2, // Basic
  LITE = 3, // Lite (表单显示用，提交时根据类型转换：Google Pay 传 3，Apple Pay 传 2)
}

/**
 * 搜索表单数据
 */
export interface MemberTypeSearchParams {
  currentPage?: number;
  pageSize?: number;
}

/**
 * 会员权益选项（用于下拉选择）
 */
export interface PrivilegeOption {
  id: number;
  titleEn: string;
  titleJa: string;
  [key: string]: any;
}

/**
 * 会员类型记录（API 响应）
 */
export interface MemberTypeRecord {
  id: number;
  productId: string; // 商店申请的商品id
  amount: number; // 现价
  originalAmount: number; // 原价
  discount: string; // 折扣
  discountDescEn?: string; // 折扣描述，七天免费描述 英文
  discountDescJa?: string; // 折扣描述，七天免费描述 日文
  type: PaymentType; // 类型：0-Apple Pay，1-Google Pay
  periodType: PeriodType; // 产品类型（0:月,1:半年,2:年）
  level: MemberLevel; // 会员等级(0:Pro,1:Premium,2:Lite)
  status: number; // 启用状态：0-禁用，1-启用
  privilegeIds?: number[]; // 关联的权益ID列表
  memberNameEn?: string; // 会员名称-英文
  memberNameJa?: string; // 会员名称-日语
  memberDescEn?: string; // 描述-英文
  memberDescJa?: string; // 描述-日语
  amountDescEn?: string; // 金额描述-英文
  amountDescJa?: string; // 金额描述-日语
  activityDescEn?: string; // 活动描述-英文
  activityDescJa?: string; // 活动描述-日语
  limitStatus?: number; // 是否期间限定：0-否，1-是
  limitIconEn?: string; // 期间限定图标 英文（左上角）
  limitIconJa?: string; // 期间限定图标 日文（右上角）
  recommendStatus?: number; // 是否推荐：0-否，1-是
  recommendIconEn?: string; // 推荐图标 英文（右上角）
  recommendIconJa?: string; // 推荐图标 日文（右上角）
  createTime: string;
  createUserId: number;
  createUserName: string;
  updateTime: string;
  updateUserId: number;
  updateUserName: string;
}

/**
 * API 分页响应
 */
export interface MemberTypeListApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: {
    total: number;
    currentPage: number;
    pageSize: number;
    records: MemberTypeRecord[];
  };
}

/**
 * API 详情响应
 */
export interface MemberTypeDetailApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: MemberTypeRecord;
}

/**
 * 分页响应（内部使用）
 */
export interface MemberTypeListResponse {
  records: MemberTypeRecord[];
  total: number;
  currentPage: number;
  pageSize: number;
}

/**
 * 会员类型表单数据
 */
export interface MemberTypeFormData {
  productId: string; // 商店申请的商品id
  amount: number; // 现价
  originalAmount: number; // 原价
  discount: string; // 折扣
  discountDescEn?: string; // 折扣描述，七天免费描述 英文
  discountDescJa?: string; // 折扣描述，七天免费描述 日文
  type: PaymentType; // 类型：0-Apple Pay，1-Google Pay
  periodType: PeriodType; // 产品类型（0:月,1:半年,2:年）
  level: MemberLevel; // 会员等级(0:Pro,1:Premium,2:Lite)
  status: number; // 启用状态：0-禁用，1-启用
  privilegeIds?: number[]; // 关联的权益ID列表
  memberNameEn?: string; // 会员名称-英文
  memberNameJa?: string; // 会员名称-日语
  memberDescEn?: string; // 描述-英文
  memberDescJa?: string; // 描述-日语
  amountDescEn?: string; // 金额描述-英文
  amountDescJa?: string; // 金额描述-日语
  activityDescEn?: string; // 活动描述-英文
  activityDescJa?: string; // 活动描述-日语
  limitStatus?: number; // 是否期间限定：0-否，1-是
  limitIconEn?: string; // 期间限定图标 英文（左上角）
  limitIconJa?: string; // 期间限定图标 日文（右上角）
  recommendStatus?: number; // 是否推荐：0-否，1-是
  recommendIconEn?: string; // 推荐图标 英文（右上角）
  recommendIconJa?: string; // 推荐图标 日文（右上角）
}

